<template>
    <div>
        <v-data-table :loading="loading" :search="search" disable-initial-sort :rows-per-page-items="rowPerPage"
            :headers="headers" :items="filtered_items" item-key="id">
            <template #headers="props">
                <tr>
                    <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers"
                        :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td class="text-no-wrap">
                        <v-menu offset-y>
                            <v-btn icon slot="activator">
                                <v-icon small color="#464D69">settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile @click="triggerDialog(props.item, 'edit')">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Chỉnh sửa / Hoàn thành
                                    </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="triggerRepairTimesheetDialog(props.item)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-account"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Chấm công
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                    <td class="text-center text-no-wrap">{{ props.item.registration_date | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.building }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.receipt_code }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.repairman_name || '-' }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.scheduled_date | formatTimeServer }}</td>
                    <td class="text-center text-wrap">{{ props.item.content }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.status }}</td>
                </tr>
            </template>
            <template #no-data>
                Chưa có thông tin
            </template>
        </v-data-table>
        <!-- trigger_edit_component: state điều khiển mở/đóng dialog
        truyền xuống cho con thông qua prop "dialog" -->
        <edit-phieu-sua-chua :chosen_repair_request="chosen_repair_request" :dialog="trigger_edit_component"
            :repairmen_name="repairmen_name" @changeDialogState="trigger_edit_component = $event" @reloadTable="getData">
        </edit-phieu-sua-chua>
        <dialog-cham-cong-trong-phieu-sua-chua :chosen_repair_request="chosen_repair_request"
            :dialog="trigger_repair_timesheet" @changeDialogState="trigger_repair_timesheet = $event"
            @reloadTable="getData" @reloadChamCong="getRepairTimesheetsData"
            :repairTimesheetsProp="repairTimesheetsProp"
            @onDialogRepairTimesheetSubmitted="$emit('onDialogRepairTimesheetSubmitted')">
        </dialog-cham-cong-trong-phieu-sua-chua>
        <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
            :rows="export_csv.rows"></export-csv-button>
    </div>
</template>

<script>

import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton';
import { buildParamQuery, formatTimeServer } from 'Helpers';
import api from '../../api';
import DialogChamCongTrongPhieuSuaChua from './DialogChamCongTrongPhieuSuaChua.vue';
import EditPhieuSuaChua from './EditPhieuSuaChua';

export default {
    name: "table-phieu-sua-chua",
    props: {
        reload_table: Number,
        download_csv_count: Number,
        loader: Boolean,
        date_start: String,
        date_end: String,
        search: String,
        repair_request_status: String,
        repairman_name: String,
        repairmen_name: Array
    },
    components: {
        EditPhieuSuaChua,
        ExportCsvButton,
        DialogChamCongTrongPhieuSuaChua
    },
    data() {
        return {
            items: [],
            loading: false,
            headers: [
                { text: "Thao tác", align: "left", sortable: false },
                { text: "Ngày đăng ký sửa chữa", align: "center", sortable: false, value: "registration_date" },
                { text: "Toà nhà", align: "center", sortable: true, value: "building" },
                { text: "Số chứng từ giấy", align: "center", sortable: true, value: "receipt_code" },
                { text: "Mã chứng từ", align: "center", sortable: true, value: "receipt_id" },
                { text: "Phòng", align: "center", sortable: true, value: "room_id" },
                { text: "Thợ sửa chữa", align: "center", sortable: true, value: "repairman_name" },
                { text: "Ngày hẹn sửa", align: "center", sortable: true, value: "scheduled_date" },
                { text: "Nội dung yêu cầu", align: "center", sortable: true, value: "content" },
                { text: "Trạng thái", align: "center", sortable: true, value: "status" },
            ],
            rowPerPage: [50, 100, 200, { "text": "Tất cả", "value": -1 }],
            chosen_repair_request: {},
            trigger_edit_component: false,
            trigger_repair_timesheet: false,
            export_csv: {
                trigger: false,
                title: "",
                rows: []
            },
            repairTimesheetsProp: []
        }
    },
    watch: {
        reload_table() {
            this.getData()
        },
        loading(nv) {
            this.$emit("update:loader", nv)
        },
        download_csv_count() {
            this.exportCSV()
        },
        chosen_repair_request() {
            this.getRepairTimesheetsData()
        }
    },
    created() {
        this.getData()
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        filtered_items() {
            return this.items.filter(item => {
                let statusMatch = true;
                let repairmanMatch = true;
                
                if (this.repair_request_status !== "Tất cả" && this.repair_request_status && item.status !== this.repair_request_status) {
                    statusMatch = false;
                }
                
                if (this.repairman_name !== "Tất cả" && this.repairman_name && item.repairman_name !== this.repairman_name) {
                    repairmanMatch = false;
                }
                
                return statusMatch && repairmanMatch;
            })
        }
    },
    methods: {
        getData: async function () {
            this.items = []
            this.loading = true;
            const params = {
                dateStart: this.date_start,
                dateEnd: this.date_end
            }
            const query = buildParamQuery(params)
            let data = await api.getRepairRequest(query)
            this.loading = false;
            if (data.status === 200) {
                this.items = data.data.map(item => {
                    return item
                })
            } else {
                console.log('Lỗi lúc tải phiếu sửa chữa');
            }
        },
        getRepairTimesheetsData: async function () {
            this.repairTimesheetsProp = []
            this.loading = true;
            const params = {
                receipt_id: this.chosen_repair_request.receipt_id
            }
            const query = buildParamQuery(params)
            let data = await api.getRepairTimesheets(query)
            this.loading = false;
            if (data.status === 200) {
                this.repairTimesheetsProp = data.data.map(item => {
                    item.completion_date = item.completion_date.substr(0, 10)
                    return item
                })
            } else {
                console.log('Lỗi lúc tải phiếu chấm công sửa chữa');
            }
        },
        triggerDialog: function (repair_request, type) {
            const isRoomExistInBuilding = this.rooms.filter(room => room.building === repair_request.building).map(room => room.room_id).includes(repair_request.room_id)

            this.chosen_repair_request = {
                ...repair_request,
                customRoomId: isRoomExistInBuilding ? "" : repair_request.room_id,
                room_id: isRoomExistInBuilding ? repair_request.room_id : "Khác",
            };

            if (type === 'edit') this.trigger_edit_component = !this.trigger_edit_component
        },
        triggerRepairTimesheetDialog: function (repair_request) {
            this.chosen_repair_request = repair_request;
            this.trigger_repair_timesheet = !this.trigger_repair_timesheet
        },
        exportCSV: function () {
            const rows = this.filtered_items.map(item => {
                return {
                    "Ngày đăng ký sửa chữa": item.registration_date
                        ? formatTimeServer(item.registration_date)
                        : "",
                    "Toà nhà": item.building || "",
                    "Số chứng từ giấy": item.receipt_code || "",
                    "Mã chứng từ": item.receipt_id || "",
                    "Phòng": item.room_id || "",
                    "Nội dung yêu cầu": item.content || "",
                    "Trạng thái": item.status || ""
                };
            });

            this.export_csv.rows = rows;
            const date = new Date().toISOString().substr(0, 10); // YYYY-MM-DD
            this.export_csv.title = `phieu-sua-chua-${date}`;
            this.export_csv.trigger = !this.export_csv.trigger;
        }

    }
}
</script>

<style scoped>
.v-list__tile__action {
    min-width: 30px;
}
</style>